import appConfig from "../appconfig";
import {BifrostBackendApi} from "../gateways/BifrostBackendApi";

const FoodCategoriesProvider = Object.freeze({
	getFoodCategories() {
		const foodCategoriesQueryParams = {
			tenantId: appConfig.tenantId
		};

		return Promise.all([
			BifrostBackendApi.get("/food-categories", {
				params: foodCategoriesQueryParams
			})
		]).then(([ foodCategories]) => {
			return {
				foodCategories
			};
		});
	},
	getFoodCategory(id, tenantId, jwtToken) {
		return BifrostBackendApi.get(`/food-categories/?id=${id}&tenantId=${tenantId}`, {
			headers: {
				Authorization: jwtToken
			}
		});
	}
});

export default FoodCategoriesProvider;
